import React from "react";
import { Reveal } from "./_shared";

const QUOTES = [
  {
    quote:
      "They were the only counsel that read every schedule, asked the questions our board hadn't yet thought to ask, and still closed on time.",
    name: "David K.",
    role: "CEO, David Aslan Group",
  },
  {
    quote:
      "The drafting was unusually clean and on point, clearly conveying the intent in the most articulate form. The professionalism was very commendable.",
    name: "Endy E.",
    role: "CEO, Deets Limited",
  },
];

const CLIENTS = [
  "Legionhill Facilitators",
  "Novotech Works",
  "Deets Limited",
  "David Aslan Group",
  "Diadem Group",
  "Fincra Technologies",
];

export default function Testimonials() {
  return (
    <section
      data-testid="testimonials-section"
      className="py-24 lg:py-32 bg-white text-charcoal relative overflow-hidden border-y border-cream-300"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 relative">
        <Reveal className="max-w-3xl">
          <span className="inline-block text-[11px] uppercase tracking-[0.28em] text-ochre-600 font-sans">
            In the words of clients
          </span>
          <h2 className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-charcoal">
            Trust earned in
            <span className="italic text-ochre-500"> rooms that matter.</span>
          </h2>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-px bg-cream-300">
          {QUOTES.map((q, i) => (
            <Reveal
              as="figure"
              key={i}
              delay={i * 0.1}
              data-testid={`testimonial-${i}`}
              className="bg-white p-8 lg:p-10"
            >
              <span className="font-serif text-6xl text-ochre-500 leading-none block">"</span>
              <blockquote className="mt-2 font-serif italic text-xl lg:text-[22px] leading-snug text-charcoal">
                {q.quote}
              </blockquote>
              <figcaption className="mt-8 pt-6 border-t border-cream-300">
                <p className="font-serif text-lg text-charcoal">{q.name}</p>
                <p className="text-[11px] uppercase tracking-[0.22em] text-ochre-600 font-sans mt-1">
                  {q.role}
                </p>
              </figcaption>
            </Reveal>
          ))}
        </div>

        <Reveal
          delay={0.15}
          data-testid="client-roster"
          className="mt-16 flex flex-wrap items-center justify-center md:justify-start gap-x-10 gap-y-6"
        >
          {CLIENTS.map((n) => (
            <span
              key={n}
              data-testid={`client-${n.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="font-serif italic text-charcoal-muted text-lg lg:text-xl"
            >
              {n}
            </span>
          ))}
        </Reveal>
      </div>
    </section>
  );
}
